export const SIGNOUT = 'signout';
export const AUTHENTICATE = 'authenticate';
export const HANDLE_SESSION_EXPIRED = 'handleSessionExpired';



// WEBPACK FOOTER //
// ./src/store/auth/auth.actions.js